import { Type } from '@sinclair/typebox';
export const getAdyenPaymentMethodsQuery = Type.Object({});
export const updateAdyenPaymentDetailsRequest = Type.Object({
    paymentData: Type.Optional(Type.String()),
    details: Type.Record(Type.String(), Type.String()),
});
export const updateAdyenPaymentSessionResponse = Type.Object({
    success: Type.Boolean(),
    errorMessage: Type.Optional(Type.String()),
    // We don't own the type so we don't have a proper type for it
    paymentsDetailsResponse: Type.Unknown(),
});
//# sourceMappingURL=schema.js.map